import { CloseOutlined } from '@ant-design/icons';
import { StoredBoat } from '@components/CompareBoats/hooks/useCompare';
import styles from '@styles/SingleBoat/Compare/compare_boat_card.module.scss';
import { getBoatName } from '@utils/getBoatName';
import { Button, Divider, Grid } from 'antd';
import Image from 'next/image';
import React, { useMemo } from 'react';

type Props = {
  boat: StoredBoat;
  removeBoat: (boat: StoredBoat) => void;
};

const CompareBoatCard: React.FC<Props> = ({ boat, removeBoat }) => {
  const boatTitle = useMemo(() => getBoatName(boat?.attributes), [boat?.attributes]);

  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();

  // const stats = [
  //   {
  //     icon: <EyeFilled />,
  //     count: total_views,
  //   },
  //   {
  //     icon: <HeartFilled />,
  //     count: favorites_count,
  //   },
  // ];

  const removeFromCompare = () => {
    removeBoat(boat);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container__card}>
        <div className={styles.card__image}>
          <Image width={170} height={95} src={boat.attributes.image.url} alt={`${boatTitle}`} />
        </div>

        <div className={styles.card__content}>
          <div className={styles.main__content}>
            <h3 className={styles.card__title}>{boatTitle}</h3>

            <ul className={styles.card__stats}>
              {/* TODO for view counts and favorite */}
              {/* {stats.map((item) => {
                const { icon, count } = item;

                return (
                  <li className={styles.stats__item} key={item?.icon?.key}>
                    {icon} <p>{count}</p>
                  </li>
                );
              })} */}
            </ul>
          </div>

          {xs && <Divider style={{ margin: '8px 0', marginBottom: 4 }} />}

          {xs ? (
            <Button type="link" onClick={() => removeFromCompare()}>
              Remove
            </Button>
          ) : (
            <Button type="text" icon={<CloseOutlined />} onClick={() => removeFromCompare()} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareBoatCard;
